<template>
  <div>
    <div class="row pl-4 pr-4">
      <div class="col-md-4">
        <label>{{ $t("nombre") }}</label>
        <input
          type="text"
          v-model="misDatos.name"
          :disabled="list === true"
          class="form-control"
          :class="{
            'is-invalid': $v.misDatos.name.$error,
            'is-valid': !$v.misDatos.name.$invalid,
          }"
        />
      </div>
      <div class="col-md-4">
        <label>{{ $t("apellidos") }}</label>
       
        <input
          type="text"
          v-model="misDatos.lastname"
          :disabled="list === true"
          class="form-control"
          :class="{
            'is-invalid': $v.misDatos.lastname.$error,
            'is-valid': !$v.misDatos.lastname.$invalid,
          }"
        />
      </div>
      <div class="col-md-4">
        <label>
          {{ $t("DNI") }}
          <small
            style="font-size:0.9em;"
            :class="{
              'is-invalid': lenDNI !== 9,
              'is-valid': lenDNI === 9,
            }"
            >&nbsp;({{ lenDNI }}/9)&nbsp;</small
          >
          <span class="required">*</span>
        </label>
        <div class="input-group mb-3">
          <div class="input-group-append">
            <input
              type="text"
              class="form-control"
              :class="{
                'is-invalid': $v.misDatos.dni.$error,
                'is-valid': !$v.misDatos.dni.$invalid,
              }"
              v-model="misDatos.dni"
            />            
            <button
              v-if="!editando"
              style="height:28px; min-width:70px;"
              class="btn btn-outline-secondary btn-sm"
              type="button"
              @click="buscarPorDni"
            >
              {{ $t("buscar") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <button
          class="btn btn-sm btn-success miBtn mr-0 float-right my-auto"
          @click.prevent="guardarRegistro"
        >
          {{ $t("guardar") }}
        </button>
        <button
          class="btn btn-sm miBtn mr-1 float-right my-auto"
          @click.prevent="cancelar"
        >
          {{ $t("cancelar") }}
        </button>
      </div>
    </div>
    <div class="row" v-if="!!notificacion.texto">
      <div
        class="col-12 text-center"
        :class="notificacion.tipo"
        v-html="notificacion.texto"
      ></div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Vuelidate from "vuelidate";
import { mapActions } from "vuex";
import { formatearNombres } from "@/_helpers/index";
import { required } from "vuelidate/lib/validators";

Vue.use(Vuelidate);

export default {
  name: "dog-cowner",
  props: ["datos", "dogId", "newReg", "editing", "list"],
  data: () => ({
    misDatos: {
      id: null,
      name: null,
      lastname: null,
      dni: null,
      dog_id: null,
    },
    titulo: "alta nuevo copropietario",
    listing: false,
    notificacion: {
      tipo: "is-invalid",
      texto: null,
    },
    editando: false,
    editandoId: null,
  }),
  validations: {
    misDatos: {
      name: { required },
      lastname: { required },
      dni: { required },
    },
  },
  methods: {
    ...mapActions("coprop", ["acBuscarUsuarioPorDni"]),
    /* funcion para buscar por un dni dado */
    buscarPorDni() {
      if (!this.misDatos.dni) return;

      if (!validarDNI(this.misDatos.dni)) {
        this.notificacion.texto = this.$t("error-validacion-dni");
        this.notificacion.tipo = "is-invalid";
        return;
      } else {
        this.notificacion.texto = null;
      }
      // console.log(this.misDatos.dni, rexp);
      //buscamos el usuario por su dni
      this.acBuscarUsuarioPorDni({ dni: this.misDatos.dni.toUpperCase() }).then(
        (res) => {
          if (res !== false) {
            this.misDatos.name = res.name;
            this.misDatos.lastname = res.lastname;
            this.notificacion.texto = this.$t("ok-dni-encontrado");
            this.notificacion.tipo = "is-valid";
          } else {
            this.notificacion.texto = this.$t("error-dni-no-encontrado");
            this.notificacion.tipo = "is-invalid";
            return;
          }
        }
      );
    },
    guardarRegistro() {
      //validamos el dni
      const validDni = validarDNI(this.misDatos.dni);
      if (!validDni) {
        this.notificacion.texto = this.$t("error-validacion-dni");
        this.notificacion.tipo = "is-invalid";
      } else {
        this.notificacion.texto = "";
      }

      //validamos con validate
      this.$v.$touch();    
      if (this.$v.$invalid || !validDni) {
        return;
      }

      //si llegamos aquí formateamos los textos
      this.misDatos.dni = this.misDatos.dni.toUpperCase();      
      this.misDatos.name = formatearNombres(this.misDatos.name);
      this.misDatos.lastname = formatearNombres(this.misDatos.lastname);

      this.$emit("emitAltaCoprop", {
        datos: this.misDatos,
        editando: this.editando,
        id: this.editandoId,
      });
      return;
    },
    cancelar: function() {
      this.$emit("emitCancelar");
    },
  },
  computed: {
    lenDNI() {
      if (!this.misDatos.dni) return 0;
      return this.misDatos.dni.length;
    },
  },
  mounted() {
    //si hay datos
    if (!!this.datos) {
      console.log("hay datos", this.datos, !this.datos);
      this.editando = true;
      this.editandoId = this.datos.editid;
      //clonamos el objeto
      this.misDatos = Object.assign(this.misDatos, this.datos);
    }
  },
};

/* funcion para validar el dni */
const validarDNI = (dni) => {
  return /^[0-9]{8}[a-zA-Z]{1}$/.test(dni);
};

</script>

<style scoped>
div.col-md-4 {
  padding: 0px 5px 0px 5px !important;
}
input {
  padding: 1px 0px 0px 10px !important;
  height: 28px;
  background-color: white;
  color: black !important;
}
input:focus {
  background-color: seashell;
  color: blue !important;
}
button.miBtn {
  min-width: 50px;
}
.pos-botones {
  margin-top: 28px;
}
</style>
